import { render, staticRenderFns } from "./DriverFeedback.vue?vue&type=template&id=135698b2&scoped=true&"
import script from "./DriverFeedback.vue?vue&type=script&lang=js&"
export * from "./DriverFeedback.vue?vue&type=script&lang=js&"
import style0 from "./DriverFeedback.vue?vue&type=style&index=0&id=135698b2&prod&scoped=true&lang=css&"
import style1 from "./DriverFeedback.vue?vue&type=style&index=1&id=135698b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135698b2",
  null
  
)

export default component.exports